import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=0574329b&scoped=true&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=0574329b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574329b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0574329b')) {
      api.createRecord('0574329b', component.options)
    } else {
      api.reload('0574329b', component.options)
    }
    module.hot.accept("./UpdateModal.vue?vue&type=template&id=0574329b&scoped=true&", function () {
      api.rerender('0574329b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/list/UpdateModal.vue"
export default component.exports